import React from "react";
import { Redirect } from "react-router-dom";
import { FuseUtils } from "@fuse/index";
import { LoginPageConfig } from "main/content/login/LoginPageConfig";
import { projectConfig } from "main/content/project/projectConfig";

const routeConfigs = [...projectConfig, LoginPageConfig];

export const routes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
  {
    path: "/",
    component: () => <Redirect to="/login" />
  }
];



// WEBPACK FOOTER //
// ./src/fuse-configs/fuseRoutesConfig.js